import React from "react";
import { motion } from "framer-motion";

import { AppWrap } from "../../wrapper";
import { images } from "../../constants";
import "./Header.scss";

const scaleVariants = {
  whileInView: {
    scale: [0, 1],
    opacity: [0, 1],
    transition: {
      duration: 1,
      ease: "easeInOut",
    },
  },
};

const Header = () => (
  <div className="app__header app__flex">
    <div className="wave wave1"></div>
    <div className="wave wave2"></div>
    <div className="wave wave2"></div>
    <div className="wave wave2"></div>
    <div className="app__header-cont">
      <motion.div
        whileInView={{ x: [-100, 0], opacity: [0, 1] }}
        transition={{ duration: 0.5 }}
        className="app__header-info"
      >
        <div className="app__header-badge">
          <div className="badge-cmp app__flex">
            <div style={{ marginLeft: 20 }}>
              <h1>
                Frontend &#38; <br />
                Web Developer{" "}
              </h1>
              <h4 className="p-description">Hi, I’m Olha Pyvovarova</h4> <br />
              <p className="p-text">
                I specialise in creating interactive experiences and functional
                interfaces using Vue, React and Design Systems.
              </p>
            </div>
          </div>
          <div className="tag-cmp">
            <div className="app__header-skills-wraps">
              {[
                images.html,
                images.sass,
                images.css,
                images.javascript,
                images.react,
                images.redux,
                images.api,
                images.vue,
                images.git,
                images.figma,
              ].map((skill, index) => (
                <div className="app__header-skills-item" key={`skill-${index}`}>
                  <img
                    className="app__header-skills-item-img"
                    src={skill}
                    alt="skill"
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      </motion.div>
      <motion.div
        whileInView={{ opacity: [0, 1] }}
        transition={{ duration: 0.5, delayChildren: 0.5 }}
        className="app__header-img"
      >
        {/* <img src={images.profilephoto} alt="profile_bg" /> */}
        {/* <img src={images.profilegreen} alt="profile_bg" /> */}
        <img src={images.photodark} alt="profile_bg" className="profile__img" />
        {/* <img src={images.photostrip} alt="profile_bg" /> */}

        <motion.img
          whileInView={{ scale: [0, 1] }}
          transition={{ duration: 1, ease: "easeInOut" }}
          src={images.circle}
          alt="profile_circle"
          className="overlay_circle"
        />
      </motion.div>
      <motion.div
        variant={scaleVariants}
        whileInView={scaleVariants.whileInView}
        className="app__header-circles"
      >
        {[images.react, images.redux, images.sass].map((circle, index) => (
          <div className="circle-cmp app__flex" key={`circle-${index}`}>
            <img src={circle} alt="circle" />
          </div>
        ))}
      </motion.div>
    </div>
  </div>
);

export default AppWrap(Header, "home");
